export var PaymentMethodStatus;
(function (PaymentMethodStatus) {
    PaymentMethodStatus["ACTIVE"] = "active";
    PaymentMethodStatus["PENDING"] = "pending";
    PaymentMethodStatus["DELETED"] = "deleted";
    PaymentMethodStatus["EXPIRED"] = "expired";
    PaymentMethodStatus["BLOCKED"] = "blocked";
})(PaymentMethodStatus || (PaymentMethodStatus = {}));
export var PaymentMethodVerificationStatus;
(function (PaymentMethodVerificationStatus) {
    PaymentMethodVerificationStatus["VERIFIED"] = "verified";
    PaymentMethodVerificationStatus["PENDING"] = "pending";
    PaymentMethodVerificationStatus["FAILED"] = "failed";
    PaymentMethodVerificationStatus["CANCELLED"] = "cancelled";
})(PaymentMethodVerificationStatus || (PaymentMethodVerificationStatus = {}));
// https://stripe.com/docs/api/cards/object#card_object-brand
export var CardBrand;
(function (CardBrand) {
    CardBrand["VISA"] = "Visa";
    CardBrand["MASTERCARD"] = "MasterCard";
    CardBrand["DISCOVER"] = "Discover";
    CardBrand["AMERICAN_EXPRESS"] = "American Express";
    CardBrand["JCB"] = "JCB";
    CardBrand["DINERS_CLUB"] = "Diners Club";
    CardBrand["EFTPOS_AUSTRALIA"] = "Eftpos Australia";
    CardBrand["UNIONPAY"] = "UnionPay";
    CardBrand["UNKNOWN"] = "Unknown";
})(CardBrand || (CardBrand = {}));
export var CardVerificationType;
(function (CardVerificationType) {
    CardVerificationType["THREE_D_SECURE"] = "3d_secure";
    CardVerificationType["CHALLENGE"] = "challenge";
    CardVerificationType["SCAN"] = "scan";
    // Widened from packages/server's declaration (core standardization audit
    // finding, PR #6397) so server can alias to this instead of redeclaring.
    CardVerificationType["TAP_TO_PAY"] = "tap_to_pay";
})(CardVerificationType || (CardVerificationType = {}));
export var BankAccountType;
(function (BankAccountType) {
    BankAccountType["CHECKING"] = "CHECKING";
    BankAccountType["SAVINGS"] = "SAVINGS";
    BankAccountType["CURRENT"] = "CURRENT";
})(BankAccountType || (BankAccountType = {}));
export var BankAccountHolderType;
(function (BankAccountHolderType) {
    BankAccountHolderType["PERSONAL"] = "personal";
    BankAccountHolderType["BUSINESS"] = "business";
})(BankAccountHolderType || (BankAccountHolderType = {}));
export { BankIdentifierType } from './AfriexBank.js';
export var AfriexCardType;
(function (AfriexCardType) {
    AfriexCardType["Credit"] = "CREDIT";
    AfriexCardType["Debit"] = "DEBIT";
    AfriexCardType["Prepaid"] = "PREPAID";
    AfriexCardType["Charge"] = "CHARGE";
    AfriexCardType["Unknown"] = "UNKNOWN";
})(AfriexCardType || (AfriexCardType = {}));
//# sourceMappingURL=AfriexPaymentMethod.js.map